import Canvas from "./canvas/reducer";
// eslint-disable-next-line
export default {
  Canvas,
};
